import React from "react";

function normalizeAttributeValue(attribute) {
  if (Array.isArray(attribute.options)) {
    return attribute.options.filter(Boolean).join(", ");
  }

  return attribute.option || attribute.value || "";
}

function ProductAttributes({ attributes = [], limit, className = "" }) {
  const visibleAttributes = attributes
    .filter((attribute) => attribute && attribute.visible !== false)
    .map((attribute) => ({
      id: attribute.id || attribute.name,
      name: attribute.name,
      value: normalizeAttributeValue(attribute),
    }))
    .filter((attribute) => attribute.name && attribute.value);

  const shownAttributes =
    typeof limit === "number"
      ? visibleAttributes.slice(0, limit)
      : visibleAttributes;

  if (shownAttributes.length === 0) {
    return null;
  }

  return (
    <div className={`product-attributes ${className}`.trim()}>
      {shownAttributes.map((attribute) => (
        <div className="product-attribute-row" key={attribute.id}>
          <span className="product-attribute-name">{attribute.name}</span>
          <span className="product-attribute-value">{attribute.value}</span>
        </div>
      ))}
    </div>
  );
}

export default ProductAttributes;
